import React, {
  useEffect,
  useState,
  useCallback,
  useInsertionEffect,
} from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";
import ErrorLabel from "../../../../../component/error_label";
import {
  actionPolicyAdd,
  resetPolicyAdd,
  actionEmployeeNamesWithCity,
  resetEmployeeNamesWithCity,
  resetGetInsurerList,
  actionGetInsurerList,
} from "./../store/index";
import $ from "jquery";
import { actionPolicyUpdate, resetUpdatePolicy } from "../../policies/store";
import { useSelector, useDispatch } from "react-redux";
import toast from "react-hot-toast";
import "flatpickr/dist/themes/material_green.css";
import Flatpickr from "react-flatpickr";
import moment from "moment";
import Select from "react-select";
import {
  TOAST_DURATION,
  TOAST_ERROR_COLOR,
  TOAST_POSITION,
  TOAST_SUCCESS_COLOR,
} from "../../../../../common/app_constant";
import { useDropzone } from "react-dropzone";
import Swal from "sweetalert2";
import { downloadFile } from "../../../../../utils";
import { ToWords } from "to-words";
import {
  actionDownload,
  resetDownloadPolicyResponse,
} from "../../dashboard/store";
import { numberWheelChange } from "../../../../../utils";
import { ENV } from "../../../../../common/constant";

const PolicyForm = (props) => {
  const { PolicyAdd, EmployeeNamesWithCity, getInsurerList } = useSelector((state) => ({
    ...state.formStore,
  }));

  const { updatePolicy } = useSelector((state) => ({
    ...state.policyStore,
  }));

  const { downloadPolicy } = useSelector((state) => ({
    ...state.dashboardStore,
  }));

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [attachment, setAttachment] = useState([]);
  const [attachment2, setAttachment2] = useState([]);
  const [policyStatus, setPolicyStatus] = useState(null);
  const [docStatus, setDocStatus] = useState(null);
  const [selectedEmpId, setSelectedEmpId] = useState(null);
  const [policyDropdownList, setPolicyDropdownList] = useState([]);
  const [selectedPolicyId, setSelectedPolicyId] = useState(null);
  const [selectedPolicyNumber, setSelectedPolicyNumber] = useState(null);
  const [employeeDetails, setEmployeeDetails] = useState(null);
  const [detailPolicies, setDetailPolicies] = useState(null);
  const [document, setDocument] = useState([]);
  // const initialData = location.state?.data;
  const [initialData, setInitialData] = useState(null);
  const [grossCalculation, setGrossCalculation] = useState(0);
  const [policyType, setPolicyType] = useState(null);
  const [isReadonly, setIsReadonly] = useState(null);
  const [currentPlan, setCurrentPlan] = useState(null);
  const [employeeDropdown, setEmployeeDropdown] = useState([]);
  const [sumInsuredText, setSumInsuredText] = useState("");
  const [watchName, setWatchName] = useState("");
  const [employeeListDropdown, setEmployeeListDropdown] = useState([]);

  const [insurerListDropdown, setInsurerListDropdown] = useState([]);

  const [loading, setLoading] = useState(false)
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    watch,
    setValue,
    getValues,
  } = useForm({
    defaultValues: {
      ...initialData,
      stamp_duty: 0,
      gst_perc: 18,
      od_brokerage_perc: 0,
      tp_brokerage_perc: 0,
      reward_perc: 0,
      enhance_brokerage_perc: 0,
      policy_received_status: "No",
      policy_doc_status: "No",
      insurer_name: ''
    },
  });

  const watchInsurerName = watch('insurer_name')
  const watchNetPremium = watch("net_premium");
  const watchTPExpiryDate = watch("tp_expiry_date");
  const watchPolicyExpiryDate = watch("policy_expiry_date");
  const watchIdv = watch("sum_insured");
  const watchPolicyStartDate = watch("policy_start_date");
  const watchOdBrokAmount = watch("od_brokerage_amount");
  const watchTpBrokAmount = watch("tp_brokerage_amount");
  const watchTotalBrokAmount = watch("total_brokerage_amount");
  const watchAddonPrem = watch("add_on_premium");
  const watchOdPrem = watch("od_premium");
  const watchRewardPerc = watch("reward_perc");
  const watchReward = watch("reward_amount");
  const watchEnhanceBrokAmount = watch("enhance_brokerage_amount");
  const watchEnhanceBrokPerc = watch("enhance_brokerage_perc");
  const watchOdBrokeragePerc = watch("od_brokerage_perc");
  const watchTpBrokeragePerc = watch("tp_brokerage_perc");
  const watchTpPrem = watch("tp_premium");
  const watchStampDuty = watch("stamp_duty");
  const watchGstPerc = watch("gst_perc");
  const watchGstAmt = watch("gst_amount");
  const watchBizType = watch("biz_type");
  const watchPolicyDocStatus = watch('policy_doc_status')


  const [insurerName, setSelectedInsurerName] = useState(null)

  const toWords = new ToWords();

  useEffect(() => {
    setInitialData(JSON.parse(localStorage.getItem("detailsData")));
    dispatch(actionEmployeeNamesWithCity({ is_name_formatted: 1, status: "ACTIVE" }));
    dispatch(actionGetInsurerList())
  }, []);

  useEffect(() => {
    if (initialData) {
      Object.keys(initialData).forEach((key) => {
        setValue(key, initialData[key]);
      });
      setValue("previous_policy_no", [initialData?.quote?.previous_policy_id]);
      setValue("user_id", [initialData?.user_id]);
      setWatchName(initialData.insured_name);
      setDocument(initialData?.documents);
      setDocStatus(initialData?.policy_doc_status);
      setSelectedPolicyId(initialData?.quote?.previous_policy_id);
      setSelectedPolicyNumber(initialData?.quote?.previous_policy_no)
      setSelectedEmpId(initialData?.user_id);
      setValue("sum_insured", Number(initialData?.sum_insured));
      setValue("price_of_vehicle_without_insurance_and_tcs", Number(initialData?.price_of_vehicle_without_insurance_and_tcs))
      setValue("od_premium", Number(initialData?.od_premium));
      setValue('payment_date', initialData.payment_date !== null ? moment(initialData.payment_date).format("DD-MM-YYYY") : '');
      setValue('registration_date', initialData.registration_date !== null ? moment(initialData.registration_date).format("DD-MM-YYYY") : '');
      setValue('policy_start_date', initialData.policy_start_date !== null ? moment(initialData.policy_start_date).format("DD-MM-YYYY") : '');
      setValue('policy_expiry_date', initialData.policy_expiry_date !== null ? moment(initialData.policy_expiry_date).format("DD-MM-YYYY") : '');
      setValue('tp_start_date', initialData.tp_start_date !== null ? moment(initialData.tp_start_date).format("DD-MM-YYYY") : '');
      setValue('tp_expiry_date', initialData.tp_expiry_date !== null ? moment(initialData.tp_expiry_date).format("DD-MM-YYYY") : '');
      setValue('insurer_name', initialData?.insurer_name)
      // setSelectedInsurerName(initialData?.insurer_name)
    }
    console.log("my data", initialData)

  }, [initialData]);

  useEffect(() => {
    if (selectedEmpId) {
      let idPolicy = employeeListDropdown.find(
        (item) => item.id === selectedEmpId
      );
      if (idPolicy) {
        setEmployeeDetails(idPolicy);
      }
    }
  }, [selectedEmpId]);

  useEffect(() => {
    if (employeeDetails) {
      const policyPrevNoDropdown = employeeDetails.userPolicyList?.map(
        (item, index) => ({
          label: item.policy_no,
          value: item.id,
          item: item,
        })
      );
      setPolicyDropdownList(policyPrevNoDropdown);
    }
  }, [employeeDetails]);


  useEffect(() => {
    if (getInsurerList) {
      dispatch(resetGetInsurerList());
      if (getInsurerList.status) {
        const insurerListDropdown = getInsurerList.data?.map(
          (item, index) => ({
            label: item?.name,
            value: item.id,
          })
        );
        if (!initialData) {
          setValue('insurer_name', insurerListDropdown[0]?.label,)

        }
        setInsurerListDropdown(insurerListDropdown);
      }
    }
  }, [getInsurerList]);

  useEffect(() => {
    if (EmployeeNamesWithCity) {
      dispatch(resetEmployeeNamesWithCity());
      if (EmployeeNamesWithCity.status) {
        setEmployeeListDropdown(EmployeeNamesWithCity.data);
        const employeeListDropdown = EmployeeNamesWithCity.data?.map(
          (item, index) => ({
            label: item.full_name_with_city,
            value: item.id,
            item: item,
          })
        );
        setEmployeeDropdown(employeeListDropdown);
      }
    }
  }, [EmployeeNamesWithCity]);

  useEffect(() => {
    if (downloadPolicy !== null) {
      dispatch(resetDownloadPolicyResponse());
      if (downloadPolicy.status === true) {
        if (downloadPolicy.status === true && Array.isArray(downloadPolicy.data.urls)) {
          downloadPolicy.data.urls.forEach(item => {
            if (item.url) {
              window.open(item.url, '_blank');
            }
          });
        }
      } else {
        switch (downloadPolicy.status_code) {
          case 400:
            toast.error(downloadPolicy.message, {
              duration: TOAST_DURATION,
              position: TOAST_POSITION,
              style: {
                color: TOAST_ERROR_COLOR,
              },
            });
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          case 401:
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          default:
        }
      }
    }
  }, [downloadPolicy]);

  useEffect(() => {
    if (policyStatus === "No") {
      setValue("policy_no", null);
    }
  }, [policyStatus]);

  useEffect(() => {
    if (policyDropdownList && policyDropdownList.length > 0) {
      const selectedPolicy = policyDropdownList.find(
        (item) => item.value === selectedPolicyId
      );
      if (selectedPolicy) {
        const policyPreviousNumber = selectedPolicy.item;
        setDetailPolicies(policyPreviousNumber);
      }
      setValue("previous_policy_no", initialData?.quote?.previous_policy_id);
    }
  }, [policyDropdownList, selectedPolicyId]);

  useEffect(() => {
    if (detailPolicies) {
      Object.keys(detailPolicies).forEach((key) => {
        if (
          key !== "product_name" &&
          key !== "previous_policy_no" &&
          key !== "user_id"
        ) {
          setValue(key, detailPolicies[key]);
        }
      });
      setDocStatus(detailPolicies?.policy_doc_status);
      const dateFieldsFromPolicies = [
        "registration_date",
        "policy_start_date",
        "payment_date",
        "policy_expiry_date",
        "tp_start_date",
        "tp_expiry_date",
      ];

      dateFieldsFromPolicies.forEach((FieldName) => {
        if (detailPolicies[FieldName]) {
          setValue(
            FieldName,
            moment(detailPolicies[FieldName]).format("DD-MM-YYYY")
          );
        }
      });

      setValue("sum_insured", detailPolicies?.sum_insured);
      setValue("od_premium", detailPolicies?.od_premium);
    }
  }, [detailPolicies]);

  useEffect(() => {
    if (employeeDropdown != null && employeeDropdown.length > 0) {
      // useEffect(() => {
      if (selectedEmpId) {
        let idPolicy = employeeListDropdown.find(
          (item) => item.id === selectedEmpId
        );
        if (idPolicy) {
          setEmployeeDetails(idPolicy);
        }
      }
      // }, [selectedEmpId]);

      // useEffect(() => {
      if (employeeDetails) {
        const policyPrevNoDropdown = employeeDetails.userPolicyList?.map(
          (item, index) => ({
            label: item.policy_no,
            value: item.id,
            item: item,
          })
        );
        setPolicyDropdownList(policyPrevNoDropdown);
      }
      // }, [employeeDetails]);
      if (initialData != null && initialData?.user_id != null) {
        setValue("user_id", initialData?.user_id);
      }
    }
  }, [employeeDropdown]);

  // useEffect(() => {
  //   let odBrokerageAmount = 0;
  //   let tpBrokerageAmount = 0;
  //   odBrokerageAmount =
  //     (Number(watchOdBrokeragePerc) *
  //       (Number(watchOdPrem) + Number(watchAddonPrem))) /
  //     100;
  //   !isNaN(odBrokerageAmount) &&
  //     setValue("od_brokerage_amount", odBrokerageAmount);
  //   tpBrokerageAmount =
  //     (Number(watchTpPrem) * Number(watchTpBrokeragePerc)) / 100;
  //   !isNaN(tpBrokerageAmount) &&
  //     setValue("tp_brokerage_amount", tpBrokerageAmount);
  // }, [
  //   watchOdPrem,
  //   watchAddonPrem,
  //   watchOdBrokeragePerc,
  //   watchTpBrokeragePerc,
  //   watchTpPrem,
  // ]);

  // useEffect(() => {
  //   let totalBrokerageAmount;
  //   totalBrokerageAmount =
  //     Number(watchOdBrokAmount) + Number(watchTpBrokAmount);
  //   !isNaN(totalBrokerageAmount) &&
  //     setValue("total_brokerage_amount", totalBrokerageAmount);
  // }, [watchTpBrokAmount, watchOdBrokAmount]);

  // useEffect(() => {
  //   let rewardAmount = 0;
  //   rewardAmount =
  //     (Number(watchRewardPerc) *
  //       (Number(watchOdPrem) + Number(watchAddonPrem))) /
  //     100;
  //   !isNaN(rewardAmount) && setValue("reward_amount", rewardAmount);
  // }, [watchOdPrem, watchAddonPrem, watchRewardPerc]);

  // useEffect(() => {
  //   let enhancedBrokerageAmount = 0;
  //   enhancedBrokerageAmount =
  //     (Number(watchEnhanceBrokPerc) *
  //       (Number(watchOdPrem) + Number(watchAddonPrem))) /
  //     100;
  //   !isNaN(enhancedBrokerageAmount) &&
  //     setValue("enhance_brokerage_amount", enhancedBrokerageAmount);
  // }, [watchOdPrem, watchAddonPrem, watchEnhanceBrokPerc]);

  // useEffect(() => {
  //   let netBrokerageAmount = 0;
  //   netBrokerageAmount =
  //     Number(watchReward) +
  //     Number(watchEnhanceBrokAmount) +
  //     Number(watchTotalBrokAmount);
  //   !isNaN(netBrokerageAmount) &&
  //     setValue("net_brokerage_amount", netBrokerageAmount);
  // }, [watchTotalBrokAmount, watchEnhanceBrokAmount, watchReward]);

  // useEffect(() => {
  //   let grossCalculation = 0;
  //   grossCalculation = Number(watchNetPremium) + Number(watchGstAmt);
  //   setGrossCalculation(grossCalculation.toFixed(4));
  //   !isNaN(grossCalculation) && setValue("gross_premium", grossCalculation);
  // }, [watchNetPremium, watchGstAmt]);

  useEffect(() => {
    const inputValue = parseFloat(watchIdv);
    const maxLimit = 1000000000;
    if (!isNaN(inputValue) && inputValue <= maxLimit) {
      const words = toWords.convert(inputValue, { currency: true });
      setSumInsuredText(words);
    } else {
      setSumInsuredText("");
    }
  }, [watchIdv]);

  useEffect(() => {
    if (policyType === "TP Only") {
      setValue("sum_insured", 0);
    } else {
      setValue(
        "sum_insured",
        initialData?.sum_insured != null
          ? Number(initialData?.sum_insured)
          : null
      );
    }
    if (watchTPExpiryDate && watchPolicyExpiryDate) {
      const isTpExpiryLaterOrEqual = moment(watchTPExpiryDate).isSameOrAfter(
        watchPolicyExpiryDate,
        "day"
      );
      if (policyType === "TP Only") {
        setValue("od_premium", 0);
      } else if (policyType === "Standalone OD") {
        if (isTpExpiryLaterOrEqual) {
          setValue("tp_premium", 0);
          setIsReadonly(true);
        } else {
          setValue("tp_premium", null);
          setIsReadonly(false);
        }
      } else {
        setValue(
          "od_premium",
          initialData?.od_premium != null
            ? Number(initialData?.od_premium)
            : null
        );
      }
    }
  }, [policyType, watchPolicyExpiryDate, watchTPExpiryDate]);

  useEffect(() => {
    setValue("insured_name", watchName);
  }, [watchName]);

  const handleDateChange = (date) => {
    const selectedDate = moment(date);
    const expiryDate = selectedDate
      .clone()
      .add(1, "years")
      .subtract(1, "days")
      .format("DD-MM-YYYY");

    setValue("policy_expiry_date", expiryDate);
    setValue("tp_expiry_date", expiryDate);
  };

  useEffect(() => {
    if (PolicyAdd) {
      dispatch(resetPolicyAdd());
      $("#add_edit_policy").prop("disabled", false);
      if (PolicyAdd.status === true) {
        setLoading(false)
        toast.success(PolicyAdd.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {
            color: TOAST_SUCCESS_COLOR,
          },
        });
        if (initialData) {
          window.close()
        } else {
          navigate(-1);
        }
      } else {
        setLoading(false)
        toast.error(PolicyAdd?.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {},
        });
      }
    }
  }, [PolicyAdd]);

  // useEffect(() => {
  //   if (updatePolicy) {
  //     dispatch(resetUpdatePolicy());
  //     if (updatePolicy.status) {
  //       toast.success(updatePolicy.message, {
  //         duration: TOAST_DURATION,
  //         position: TOAST_POSITION,
  //         style: {
  //           color: TOAST_SUCCESS_COLOR,
  //         },
  //       });
  //       navigate(-1);
  //     } else {
  //       toast.error(updatePolicy?.message, {
  //         duration: TOAST_DURATION,
  //         position: TOAST_POSITION,
  //         style: {},
  //       });
  //     }
  //   }
  // }, [updatePolicy]);

  const onDrop = useCallback((acceptedFiles) => {
    $("#document_required").addClass("d-none");
    if (attachment.length < 1) {
      setAttachment([...attachment, ...acceptedFiles]);
    } else {
    }
  });

  const onDrop2 = useCallback((acceptedFiles) => {
    $("#document-required").addClass("d-none");
    if (attachment2.length < 3) {
      setAttachment2([...attachment2, ...acceptedFiles]);
    } else {
    }
  });

  // useEffect(() => {
  //   let netPremium = 0;
  //   netPremium =
  //     Number(watchAddonPrem) +
  //     Number(watchOdPrem) +
  //     Number(watchTpPrem) +
  //     Number(watchStampDuty);
  //   !isNaN(netPremium) && setValue("net_premium", netPremium);
  // }, [watchAddonPrem, watchOdPrem, watchTpPrem, watchStampDuty, watchGstPerc]);

  // useEffect(() => {
  //   let gstAmount = 0;
  //   gstAmount = (
  //     (Number(watchNetPremium) - Number(watchStampDuty)) *
  //     (Number(watchGstPerc) / 100)
  //   ).toFixed(2);

  //   !isNaN(gstAmount) && setValue("gst_amount", gstAmount);
  // }, [watchStampDuty, watchGstPerc, watchNetPremium]);

  const {
    getRootProps: getRootProps2,
    getInputProps: getInputProps2,
    fileRejections: fileRejections2,
  } = useDropzone({
    accept: {
      accept: [
        ".pdf",
        ".doc",
        ".docx",
        ".jpeg",
        ".jpg",
        ".png",
        ".xls",
        ".xlsx"
      ]
    },
    multiple: true,
    maxFiles: 3,
    maxSize: 5 * 1024 * 1024, // 5 MB file size limit
    onDrop: onDrop2,
  });

  const fileRejectionItems2 = fileRejections2.map(({ file, errors }) => (
    <div key={file.path} className="text-danger mt-2 small">
      <strong>{file.name}</strong> - {(file.size / 1024 / 1024).toFixed(2)} MB
      {errors.map((e, index) => (
        <div key={index}> {e.message}</div>
      ))}
    </div>
  ));

  const removeFile = (file) => () => {
    const newFiles = [...attachment];
    newFiles.splice(newFiles.indexOf(file), 1);
    setAttachment(newFiles);
  };

  const removeFile2 = (file) => () => {
    const newFiles = [...attachment2];
    newFiles.splice(newFiles.indexOf(file), 1);
    setAttachment2(newFiles);
  };
  const removeAll2 = () => {
    setAttachment2([]);
  };
  const removeAll = () => {
    setAttachment([]);
  };
  const thumbs2 = attachment2?.map((file) => (
    <>
      <div className="card mt-3" key={file.name}>
        <div className="card-body d-flex justify-content-between">
          <span className="my-auto"> {file.name} </span>
          <button
            type="reset"
            className="btn btn-sm btn-primary"
            onClick={removeFile2(file)}
          >
            X
          </button>
        </div>
      </div>
    </>
  ));

  console.log('watchInsurerName', watchInsurerName)

  const onSubmit = (data) => {
    delete data.userDetails
    if (selectedPolicyId === null || watchBizType == "New" || selectedPolicyId === undefined) {
      delete data.previous_policy_id;
    } else {
      data.previous_policy_id = selectedPolicyId;
    }
    if (selectedPolicyNumber === null || selectedPolicyNumber === undefined) {
      delete data.previous_policy_no
    } else {
      data.previous_policy_no = selectedPolicyNumber
    }
    Object.keys(data).forEach((key) => {
      if (
        data[key] == undefined ||
        data[key] == null ||
        data[key] == "Invalid date"
      ) {
        delete data[key];
      }
    });
    const dateFields = [
      "payment_date",
      "policy_start_date",
      "tp_start_date",
      "policy_expiry_date",
      "tp_expiry_date",
      "registration_date",
    ];
    dateFields.forEach((fieldName) => {
      if (data[fieldName]) {
        data[fieldName] = moment(data[fieldName], "DD-MM-YYYY").format(
          "YYYY-MM-DD"
        );
      }
    });



    let files = [];

    if (attachment2.length > 0) {
      attachment2.forEach((objImage, index) => {
        files.push({
          name: "file",
          value: objImage,
        });
      });
    }
    console.log("insuree name", data?.insurer_name)
    var input = { ...data };
    input.user_id = selectedEmpId;
    input.insurer_name = data?.insurer_name?.label || watchInsurerName;

    if (!(docStatus === "Yes" && policyStatus === "No")) {
      if (initialData) {
        $("#add_edit_policy").prop("disabled", true);
        dispatch(
          actionPolicyAdd({
            dynamic_url: "edit",
            input,
            files,
          })
        );
        setLoading(true)
      } else {
        if ((docStatus === "Yes" || watchPolicyDocStatus === 'Yes') && attachment2.length) {
          $("#add-edit-policy-loader").removeClass("hidden");
          dispatch(
            actionPolicyAdd({
              dynamic_url: "add",
              input,
              files,
            })
          );
          setLoading(true)
        } else if (docStatus === "No" || watchPolicyDocStatus === 'No') {
          $("#add-edit-policy-loader").removeClass("hidden");
          dispatch(
            actionPolicyAdd({
              dynamic_url: "add",
              input,
              files,
            })
          );
          setLoading(true)
        } else {
          $("#document_required").removeClass("d-none");
        }
      }
    }
  };

  return (
    <>
      <section className="pb-5">
        <div className="card mb-5 mt-6">
          <div className="card-header bg-primary  d-flex justify-content-between">
            Policy {initialData ? "Edit" : "Add"}{" "}
            {
              !initialData &&
              <h6
                className="text-white mb-0 cursor-pointer"
                onClick={(event) => {
                  event.preventDefault();
                  navigate(-1);
                }}
              >
                {" "}
                Back
              </h6>
            }
          </div>
          <div className="card-body">
            <form
              noValidate
              autoComplete="Off"
              onSubmit={handleSubmit(onSubmit)}
            >
              <div className="form-body">
                <div className="row mb-3">
                  {/* Vehical Details */}
                  <div className="col-12 border-bottom mb-2">
                    <h6 className="text-primary">Vehicle Details</h6>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Biz Type&nbsp;<span className="danger">*</span>
                      </label>
                      <select
                        className="form-control"
                        id="biz_type"
                        name="biz_type"
                        placeholder="Select..."
                        {...register("biz_type", {
                          required: "This is required.",
                        })}
                      >
                        <option value="Rollover">Rollover</option>
                        <option value="Renewal">Renewal</option>
                        <option value="New">New</option>
                        <option value="Personal">Personal</option>
                      </select>
                      {errors.biz_type && (
                        <ErrorLabel message={errors.biz_type?.message} />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Employee Name&nbsp;<span className="danger">*</span>
                      </label>

                      <Controller
                        name="user_id"
                        control={control}
                        rules={{ required: "This is required." }}
                        render={({ field }) => (
                          <select
                            className="form-control"
                            {...field}
                            onChange={(e) => {
                              const value = e.target.value;
                              field.onChange(value);

                              const selected = employeeDropdown.find(
                                (emp) => String(emp.value) === value
                              );

                              if (selected) {
                                setSelectedEmpId(selected.value);
                                setWatchName(selected.item.full_name);
                              }
                            }}
                          >
                            <option value="">Select</option>
                            {employeeDropdown.map((emp) => (
                              <option key={emp.value} value={emp.value}>
                                {emp.label}
                              </option>
                            ))}
                          </select>
                        )}
                      />

                      {errors.user_id && (
                        <ErrorLabel message={errors.user_id?.message} />
                      )}
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Customer Group&nbsp;
                        <span className="danger">*</span>
                      </label>
                      <input
                        className="form-control"
                        id="customer_group"
                        name="customer_group"
                        value={ENV === 'prod' ? "M/S AXIS BANK LIMITED" : 'XYZ Corporation'}
                        readOnly
                        {...register("customer_group", {})}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Insured Name(Customer Name)
                        <span className="danger">*</span>
                      </label>
                      <input
                        className="form-control"
                        id="insured_name"
                        name="insured_name"
                        {...register("insured_name", {
                          pattern: {
                            value: /^[A-Za-z. ]*$/,
                            message: "Special characters are not allowed",
                          },
                        })}
                      />
                      {errors.insured_name && (
                        <ErrorLabel message={errors.insured_name?.message} />
                      )}
                    </div>
                  </div>
                  {watchBizType != "New" ? (
                    <div className="col-12 col-md-3 mb-3">
                      <div className="form-group">
                        <label className="label-control">
                          Previous Policy No
                          {/* <span className="danger">*</span> */}
                        </label>
                        <Controller
                          name="previous_policy_no"
                          control={control}
                          // rules={{
                          //   validate: (value) =>
                          //     watchBizType === "New" || value
                          //       ? true
                          //       : "This is required.",
                          // }}
                          render={({ field }) => (
                            <select
                              className="form-control"
                              {...field}
                              disabled={watchBizType === "New"}
                              onChange={(e) => {
                                const value = e.target.value;
                                field.onChange(value);

                                const selected = policyDropdownList.find(
                                  (p) => String(p.value) === value
                                );

                                if (selected) {
                                  setSelectedPolicyId(selected.value);
                                  setSelectedPolicyNumber(selected.label);
                                }
                              }}
                            >
                              <option value="">Select</option>
                              {policyDropdownList.map((p) => (
                                <option key={p.value} value={p.value}>
                                  {p.label}
                                </option>
                              ))}
                            </select>
                          )}
                        />

                        {errors.previous_policy_no && (
                          <ErrorLabel
                            message={errors.previous_policy_no?.message}
                          />
                        )}
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Product Name
                        <span className="danger">*</span>
                      </label>
                      <select
                        className="form-control"
                        id="product_name"
                        name="product_name"
                        placeholder="Select.."
                        {...register("product_name", {
                          required: "This is required.",
                        })}
                      >
                        <option value="Private Car">Private Car</option>
                      </select>
                      {errors.product_name && (
                        <ErrorLabel message={errors.policy_type?.message} />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Policy Type
                        <span className="danger">*</span>
                      </label>
                      <select
                        className="form-control"
                        id="policy_type"
                        name="policy_type"
                        placeholder="Select.."
                        onChangeCapture={(event) => {
                          const selectedOption =
                            event.target.options[event.target.selectedIndex];
                          const selectedLabel = selectedOption.label;
                          setPolicyType(selectedLabel);
                        }}
                        {...register("policy_type", {
                          required: "This is required.",
                        })}
                      >
                        <option value="">Select Policy Type </option>
                        <option value="Package Policy">Package Policy</option>
                        <option value="Standalone OD">Standalone OD</option>
                        <option value="TP Only">TP Only</option>
                        <option value="Others">Others</option>
                        {
                          watchBizType === 'New' && <option value="Bundle plan (1+3)">Bundle plan (1+3)</option>
                        }

                      </select>
                      {errors.policy_type && (
                        <ErrorLabel message={errors.policy_type?.message} />
                      )}
                    </div>
                  </div>

                  {/* <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Policy Sub Type
                        <span className="danger">*</span>
                      </label>
                      <select
                        className="form-control"
                        id="sub_type"
                        name="sub_type"
                        placeholder="Select.."
                        onChangeCapture={(event) => {
                          const selectedOption =
                            event.target.options[event.target.selectedIndex];
                          const selectedLabel = selectedOption.label;
                          setPolicyType(selectedLabel);
                        }}
                        {...register("sub_type", {
                          required: "This is required.",
                        })}
                      >
                        <option value="">Select Policy Sub Type </option>
                        <option value="Excavator">Excavator</option>
                        <option value="Tipper">Tipper</option>
                        <option value="Water tanker">Water tanker</option>
                        <option value="Diesel tanker">Diesel tanker</option>
                        <option value="Payloader">Payloader</option>
                        <option value="Motor grader">Motor grader</option>
                        <option value="Dozer">Dozer</option>
                        <option value="Crane">Crane</option>
                      </select>
                      {errors.sub_type && (
                        <ErrorLabel message={errors.sub_type?.message} />
                      )}
                    </div>
                  </div> */}
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Policy Number Received Status
                        <span className="danger">*</span>
                      </label>
                      <select
                        className="form-control"
                        id="policy_received_status"
                        name="policy_received_status"
                        placeholder="Select.."
                        onChangeCapture={(event) => {
                          const selectedOption =
                            event.target.options[event.target.selectedIndex];
                          const selectedLabel = selectedOption.label;
                          setPolicyStatus(selectedLabel);
                        }}
                        {...register("policy_received_status", {
                          required: "This is required.",
                        })}
                      >
                        <option value="">Select Status </option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                      {errors.policy_received_status && (
                        <ErrorLabel message={errors.policy_type?.message} />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Policy No&nbsp;<span className="danger">*</span>
                      </label>
                      <input
                        className="form-control"
                        id="policy_no"
                        name="policy_no"
                        placeholder="Enter"
                        readOnly={policyStatus === "No" ? true : false}
                        {...register("policy_no", {
                          required:
                            policyStatus === "Yes"
                              ? "This field is required."
                              : null,
                          // pattern: {
                          //   value: /^[a-zA-Z0-9 ,\/\\_\.\#\-]*$/,
                          //   message: "Please enter a valid policy number.",
                          // },
                          maxLength: {
                            value: 100,
                            message: "Policy number cannot exceed 100 characters.",
                          },
                        })}
                      />
                      {errors.policy_no && (
                        <ErrorLabel message={errors.policy_no?.message} />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Insurer Name&nbsp;<span className="danger">*</span>
                      </label>

                      <Controller
                        name="insurer_name"
                        control={control}
                        defaultValue=""
                        rules={{ required: "This is required." }}
                        render={({ field }) => (
                          <select
                            className="form-control"
                            {...field}
                            value={field.value || ""}
                            onChange={(e) => {
                              const value = e.target.value;
                              field.onChange(value);
                            }}
                          >
                            <option value="">Select</option>
                            {insurerListDropdown.map((insurer) => (
                              <option key={insurer.label} value={String(insurer.label)}>
                                {insurer.label}
                              </option>
                            ))}
                          </select>
                        )}
                      />



                      {/* <Controller
                        name="insurer_name"
                        control={control}
                        rules={{ required: "This is required." }}
                        render={({ field: { onChange, value, ...rest } }) => (
                          <select
                            className="form-control"
                            id="insurer_name"
                            value={value}
                            onChange={(e) => {
                              onChange(e); // <-- update form value
                              // your custom logic here
                              console.log("Selected Insurer:", e.target.value);
                            }}
                            {...rest}
                          >
                            <option value="">Select Insurer Name</option>
                            {insurerListDropdown.map((insurer, index) => (
                              <option key={index} value={insurer.label}>
                                {insurer.label}
                              </option>
                            ))}
                          </select>
                        )}
                      /> */}



                      {/* <input
                        className="form-control"
                        id="insurer_name"
                        name="insurer_name"
                        onChangeCapture={(event) =>
                        (event.target.value =
                          event.target.value.toUpperCase())
                        }
                        defaultValue="TATA AIG GENERAL INSURANCE"
                        {...register("insurer_name", {
                          required: "Insurer name is required",
                          maxLength: {
                            value: 50,
                            message:
                              "Insurer name should not exceed 50 characters",
                          },
                        })}
                      /> */}
                      {errors.insurer_name && (
                        <ErrorLabel message={errors.insurer_name?.message} />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div class="form-group has-search">
                      <label for="policy_start_date" class="form-label">
                        Policy Start Date<span class="text-danger">*</span>
                      </label>
                      <span class="fa fa-calendar form-control-feedback"></span>
                      <Controller
                        name="policy_start_date"
                        id="policy_start_date"
                        control={control}
                        render={({ field }) => (
                          <Flatpickr
                            {...field}
                            onChange={(value) => {
                              var date = new Date(value).toISOString();
                              handleDateChange(date);
                              setValue(
                                "policy_start_date",
                                moment(date).format("DD-MM-YYYY")
                              );
                              setValue(
                                "tp_start_date",
                                moment(date).format("DD-MM-YYYY")
                              );

                              if (policyType === 'Bundle plan (1+3)') {
                                setValue(
                                  "tp_expiry_date",
                                  moment(date).add('3', 'year').subtract('1', 'day').format("DD-MM-YYYY")
                                );
                              }
                            }}
                            id="disabled-picker"
                            className="form-control"
                            options={{
                              dateFormat: "d-m-Y",
                              enableTime: false,
                            }}
                          />
                        )}
                        rules={{
                          required: "This is required.",
                        }}
                      />
                      {errors.policy_start_date && (
                        <ErrorLabel
                          message={errors.policy_start_date?.message}
                        />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div class="form-group has-search">
                      <label for="policy_expiry_date" class="form-label">
                        Policy Expiry Date<span class="text-danger">*</span>
                      </label>
                      <span class="fa fa-calendar form-control-feedback"></span>
                      <Controller
                        name="policy_expiry_date"
                        id="policy_expiry_date"
                        control={control}
                        render={({ field }) => (
                          <Flatpickr
                            {...field}
                            onChange={(value) => {
                              var date = new Date(value).toISOString();
                              setValue(
                                "policy_expiry_date",
                                moment(date).format("DD-MM-YYYY")
                              );
                              if (policyType != 'Bundle plan (1+3)') {
                                setValue(
                                  "tp_expiry_date",
                                  moment(date).format("DD-MM-YYYY")
                                );
                              }
                            }}
                            id="disabled-picker"
                            className="form-control"
                            options={{
                              dateFormat: "d-m-Y",
                              enableTime: false,
                            }}
                          />
                        )}
                        rules={{
                          required: "This is required.",
                        }}
                      />
                      {errors.policy_expiry_date && (
                        <ErrorLabel
                          message={errors.policy_expiry_date?.message}
                        />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div class="form-group has-search">
                      <label for="tp_start_date" class="form-label">
                        TP Start Date<span class="text-danger">*</span>
                      </label>
                      <span class="fa fa-calendar form-control-feedback"></span>
                      <Controller
                        name="tp_start_date"
                        id="tp_start_date"
                        control={control}
                        render={({ field }) => (
                          <Flatpickr
                            {...field}
                            onChange={(value) => {
                              var date = new Date(value).toISOString();
                              setValue(
                                "tp_start_date",
                                moment(date).format("DD-MM-YYYY")
                              );
                            }}
                            id="disabled-picker"
                            className="form-control"
                            options={{
                              dateFormat: "d-m-Y",
                              enableTime: false,
                            }}
                          />
                        )}
                        rules={{
                          required: "This is required.",
                        }}
                      />
                      {errors.tp_start_date && (
                        <ErrorLabel message={errors.tp_start_date?.message} />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div class="form-group has-search">
                      <label for="expiryDate" class="form-label">
                        TP Expiry Date<span class="text-danger">*</span>
                      </label>
                      <span class="fa fa-calendar form-control-feedback"></span>
                      <Controller
                        name="tp_expiry_date"
                        id="tp_expiry_date"
                        control={control}
                        render={({ field }) => (
                          <Flatpickr
                            {...field}
                            onChange={(value) => {
                              var date = new Date(value).toISOString();
                              setValue(
                                "tp_expiry_date",
                                moment(date).format("DD-MM-YYYY")
                              );
                            }}
                            id="disabled-picker"
                            className="form-control"
                            options={{
                              dateFormat: "d-m-Y",
                              enableTime: false,
                            }}
                          />
                        )}
                        rules={{
                          required: "This is required.",
                        }}
                      />
                      {errors.tp_expiry_date && (
                        <ErrorLabel message={errors.tp_expiry_date?.message} />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        RTO Details
                        <span className="danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="rto_details"
                        name="rto_details"
                        {...register("rto_details", {
                          required: "This is required.",
                        })}
                      />
                      {errors.rto_details && (
                        <ErrorLabel message={errors.rto_details?.message} />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Vehicle Number(Reg. No.)&nbsp;
                      </label>
                      <input
                        className="form-control"
                        id="vehicle_no"
                        name="vehicle_no"
                        maxLength={10}
                        {...register("vehicle_no", {
                          required:
                            watchBizType === "New" ? false : "This is required",
                          pattern: {
                            value: /^[a-zA-Z0-9]{1,10}$/i,
                            message: "Please enter a valid vehicle number",
                          },
                        })}
                        onChange={(e) => {
                          const inputValue = e.target.value.toUpperCase();
                          setValue("vehicle_no", inputValue, {
                            shouldValidate: true,
                          });
                        }}
                      />
                      {errors.vehicle_no && (
                        <ErrorLabel message={errors.vehicle_no?.message} />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Vehicle Make&nbsp;
                        <span className="danger">*</span>
                      </label>
                      <input
                        className="form-control"
                        id="vehicle_make"
                        name="vehicle_make"
                        {...register("vehicle_make", {
                          required: "This is required.",
                        })}
                      />
                      {errors.vehicle_make && (
                        <ErrorLabel message={errors.vehicle_make?.message} />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Vehicle Model&nbsp;
                        <span className="danger">*</span>
                      </label>
                      <input
                        className="form-control"
                        id="vehicle_model"
                        name="vehicle_model"
                        {...register("vehicle_model", {
                          required: "This is required.",
                        })}
                      />
                      {errors.vehicle_model && (
                        <ErrorLabel message={errors.vehicle_model?.message} />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Vehicle Variant&nbsp;
                        <span className="danger">*</span>
                      </label>
                      <input
                        className="form-control"
                        id="vehicle_variant"
                        name="vehicle_variant"
                        {...register("vehicle_variant", {
                        })}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">Vehicle Type</label>
                      <select
                        id="vehicle_type"
                        name="vehicle_type"
                        className="form-control"
                        {...register("vehicle_type", {
                          required: "This is required.",
                        })}
                      >
                        <option value="MPV SU">MPV SU</option>
                        <option value="UHE">UHE</option>
                        <option value="HE">HE</option>
                        <option value="Compact">Compact</option>
                        <option value="Mid size">Mid size</option>
                        <option value="Mini">Mini</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Seating Capacity&nbsp;
                        <span className="danger">*</span>
                      </label>
                      <input
                        type="number"
                        onFocus={numberWheelChange}
                        className="form-control"
                        id="seating_capacity"
                        name="seating_capacity"
                        {...register("seating_capacity", {
                          required: "This is required.",
                          pattern: {
                            value: /^(10|[0-9])$/,
                            message:
                              "Please enter a valid number between 0 and 10.",
                          },
                        })}
                      />
                      {errors.seating_capacity && (
                        <ErrorLabel
                          message={errors.seating_capacity?.message}
                        />
                      )}
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div class="form-group has-search">
                      <label for="registration_date" class="form-label">
                        Registration Date<span class="text-danger">*</span>
                      </label>
                      <span class="fa fa-calendar form-control-feedback"></span>
                      <Controller
                        name="registration_date"
                        id="registration_date"
                        control={control}
                        render={({ field }) => (
                          <Flatpickr
                            {...field}
                            onChange={(value) => {
                              var date = new Date(value).toISOString();
                              setValue(
                                "registration_date",
                                moment(date).format("DD-MM-YYYY")
                              );
                            }}
                            id="disabled-picker"
                            className="form-control"
                            options={{
                              dateFormat: "d-m-Y",
                              enableTime: false,
                              maxDate: moment(watchPolicyStartDate)
                                .add(180, "days")
                                .toDate(),
                            }}
                          />
                        )}
                        rules={{
                          required:
                            watchBizType === "New"
                              ? false
                              : "This is required.",
                        }}
                      />
                      {errors.registration_date && (
                        <ErrorLabel
                          message={errors.registration_date?.message}
                        />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Fuel Type
                        <span className="danger">*</span>
                      </label>
                      <select
                        className="form-control"
                        id="fuel_type"
                        name="fuel_type"
                        placeholder="Select.."
                        {...register("fuel_type", {
                          required: "This is required.",
                        })}
                      >
                        <option value="Petrol">Petrol</option>
                        <option value="CNG">CNG</option>
                        <option value="Diesel">Diesel</option>
                        <option value="ELECTRIC">ELECTRIC</option>
                        <option value="HYBRID">HYBRID </option>
                      </select>
                      {errors.fuel_type && (
                        <ErrorLabel message={errors.fuel_type?.message} />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Cubic capacity (CC)
                      </label>
                      <input
                        type="number"
                        onFocus={numberWheelChange}
                        className="form-control"
                        id="cubic_capacity"
                        name="cubic_capacity"
                        {...register("cubic_capacity", {
                          required: "This is required.",
                          min: {
                            value: 50,
                            message:
                              "Please enter a value greater than or equal to 50.",
                          },
                          pattern: {
                            value: /^[0-9]\d*$/,
                            message:
                              "Please enter a valid non-decimal number greater than 50.",
                          },
                        })}
                      />
                      {errors.cubic_capacity && (
                        <ErrorLabel message={errors.cubic_capacity?.message} />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Vehicle Engine No&nbsp;<span className="danger">*</span>
                      </label>
                      <input
                        className="form-control"
                        id="engine_no"
                        name="engine_no"
                        maxlength={20}
                        {...register("engine_no", {
                          required:
                            "Engine Number must be of minimum 5-digits",
                          pattern: {
                            value: /^[a-zA-Z0-9\-\.#]*$/,
                            message:
                              "Engine Number can only contain alphabets and numbers.",
                          },
                          minLength: {
                            value: 5,
                            message:
                              "Engine Number must be of minimum 5-digits",
                          },
                          maxLength: {
                            value: 25,
                            message:
                              "Engine Number must be of minimum 25-digits",
                          }
                        })}
                        onChange={(e) => {
                          e.target.value = e.target.value.toUpperCase();
                        }}
                      />
                      {errors.engine_no && (
                        <ErrorLabel message={errors.engine_no?.message} />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Chassis Number&nbsp;<span className="danger">*</span>
                      </label>
                      <input
                        className="form-control"
                        id="chassis"
                        name="chassis"
                        maxLength={17}
                        {...register("chassis", {
                          required: "This is required.",
                          pattern: {
                            value: /^[a-zA-Z0-9\-\.#]*$/,
                            message:
                              "Chassis Number can only contain alphabets and numbers.",
                          },
                        })}
                        onChange={(e) => {
                          e.target.value = e.target.value.toUpperCase();
                        }}
                      />
                      {errors.chassis && (
                        <ErrorLabel message={errors.chassis?.message} />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Claims History<span className="danger">*</span>
                      </label>
                      <select
                        className="form-control"
                        id="claims"
                        name="claims"
                        placeholder="Select.."
                        {...register("claims", {})}
                      >
                        <option value="">Claims</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">Current NCB</label>
                      <select
                        className="form-control"
                        id="ncb_current_year"
                        name="ncb_current_year"
                        {...register("ncb_current_year", { required: "This is required." })}
                      >
                        <option value="">Current NCB</option>
                        <option value="0">0%</option>
                        <option value="20">20%</option>
                        <option value="25">25%</option>
                        <option value="35">35%</option>
                        <option value="45">45%</option>
                        <option value="50">50%</option>
                        <option value="60">60%</option>
                      </select>
                      {errors.ncb_current_year && (
                        <ErrorLabel
                          message={errors.ncb_current_year?.message}
                        />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Price Of Vehicle Without ( Insurance & TCS )
                      </label>
                      <input
                        className="form-control"
                        type="number"
                        // onFocus={numberWheelChange}
                        id="price_of_vehicle_without_insurance_and_tcs"
                        name="price_of_vehicle_without_insurance_and_tcs"
                        {...register("price_of_vehicle_without_insurance_and_tcs", {
                        })}
                      />
                      {errors.price_of_vehicle_without_insurance_and_tcs && (
                        <ErrorLabel message={errors.price_of_vehicle_without_insurance_and_tcs?.message} />
                      )}
                    </div>
                  </div>
                  {/* Premium Details */}
                  <div className="col-12 border-bottom mb-2">
                    <h6 className="text-primary">Premium Details</h6>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        IDV<span className="danger">*</span>
                      </label>
                      <input
                        className="form-control"
                        type="number"
                        onFocus={numberWheelChange}
                        id="sum_insured"
                        name="sum_insured"
                        placeholder="Enter"
                        {...register("sum_insured", {
                          required: "This is required, Enter 0 if NA",
                          pattern: {
                            value: /^[0-9]\d*$/,
                            message: "Please enter a valid non-decimal number",
                          },
                          max: {
                            value: 1000000000,
                            message: "Maximum limit exceeded",
                          },
                        })}
                      />
                      {sumInsuredText && !errors.sum_insured ? (
                        <p className="text-success mt-1">{sumInsuredText}</p>
                      ) : (
                        ""
                      )}
                      {errors.sum_insured && (
                        <ErrorLabel message={errors.sum_insured?.message} />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Current Plan&nbsp;<span className="danger">*</span>
                      </label>
                      <select
                        id="current_plan"
                        name="current_plan"
                        className="form-control"
                        {...register("current_plan", {
                          required: "This is required.",
                        })}
                        onChangeCapture={(event) => {
                          const selectedOption =
                            event.target.options[event.target.selectedIndex];
                          const selectedLabel = selectedOption.label;
                          setCurrentPlan(selectedLabel);
                          if (
                            selectedLabel === "TP Only" ||
                            selectedLabel === "Comprehensive"
                          ) {
                            setValue("add_on_premium", 0);
                          } else {
                            setValue("add_on_premium", null);
                          }
                        }}
                      >
                        <option value="">Current Plan</option>
                        <option value="TP Only">TP Only</option>
                        <option value="Comprehensive">Comprehensive</option>
                        <option value="Add_On_1">Add On 1</option>
                        <option value="Add_On_2">Add On 2</option>
                      </select>
                      {errors.current_plan && (
                        <ErrorLabel message={errors.current_plan?.message} />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        OD Premium&nbsp;<span className="danger">*</span>
                      </label>
                      <input
                        className="form-control"
                        type="number"
                        onFocus={numberWheelChange}
                        id="od_premium"
                        name="od_premium"
                        readOnly={policyType == "TP Only" ? true : false}
                        {...register("od_premium", {
                          required: policyType == "TP Only" ? "This is required." : false,
                        })}
                      />
                      {errors.od_premium && (
                        <ErrorLabel message={errors.od_premium?.message} />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        TP Premium&nbsp;<span className="danger">*</span>
                      </label>
                      <input
                        type="number"
                        onFocus={numberWheelChange}
                        className="form-control"
                        id="tp_premium"
                        readOnly={isReadonly}
                        name="tp_premium"
                        {...register("tp_premium", {
                          required: "This is required.",
                          validate: (value) => {
                            if (policyType === 'Bundle plan (1+3)' && parseFloat(value) <= 0) {
                              return "For Bundle plan (1+3), TP Premium must be greater than 0.";
                            }
                            return true;
                          }
                        })}
                      />
                      {errors.tp_premium && (
                        <ErrorLabel message={errors.tp_premium?.message} />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Addon Premium&nbsp;<span className="danger">*</span>
                      </label>
                      <input
                        type="number"
                        onFocus={numberWheelChange}
                        className="form-control"
                        id="add_on_premium"
                        readOnly={
                          currentPlan === "TP Only" ||
                          currentPlan === "Comprehensive"
                        }
                        name="add_on_premium"
                        {...register("add_on_premium", {
                          required: "This is required.",
                        })}
                      />
                      {errors.add_on_premium && (
                        <ErrorLabel message={errors.add_on_premium?.message} />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Stamp Duty <span className="danger">*</span>
                      </label>
                      <input
                        type="number"
                        onFocus={numberWheelChange}
                        className="form-control"
                        id="stamp_duty"
                        name="stamp_duty"
                        {...register("stamp_duty", {
                          required: "This is required.",
                        })}
                      />
                      {errors.stamp_duty && (
                        <ErrorLabel message={errors.stamp_duty?.message} />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Net Premium&nbsp;<span className="danger">*</span>
                      </label>
                      <input
                        className="form-control"
                        type="number"
                        onFocus={numberWheelChange}
                        id="net_premium"
                        name="net_premium"
                        {...register("net_premium", {
                          required: "This is required.",
                        })}
                      />
                      {errors.net_premium && (
                        <ErrorLabel message={errors.net_premium?.message} />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        GST (%)<span className="danger">*</span>
                      </label>
                      <input
                        className="form-control"
                        type="number"
                        onFocus={numberWheelChange}
                        id="gst_perc"
                        name="gst_perc"
                        {...register("gst_perc", {
                          required: "This is required.",
                          max: {
                            value: 28,
                            message: "Maximum limit exceeded",
                          },
                        })}
                      />
                      {errors.gst_perc && (
                        <ErrorLabel message={errors.gst_perc?.message} />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        GST Amount<span className="danger">*</span>
                      </label>
                      <input
                        className="form-control"
                        type="number"
                        onFocus={numberWheelChange}
                        id="gst_amount"
                        name="gst_amount"
                        {...register("gst_amount", {
                          required: "This is required.",
                        })}
                      />
                      {errors.gst_amount && (
                        <ErrorLabel message={errors.gst_amount?.message} />
                      )}
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Gross Premium&nbsp;<span className="danger">*</span>
                      </label>
                      <input
                        className="form-control"
                        id="gross_premium"
                        type="number"
                        name="gross_premium"
                        // value={grossCalculation}
                        {...register("gross_premium", {
                          required: "This is required.",
                        })}
                      />
                      {errors.gross_premium && (
                        <ErrorLabel message={errors.gross_premium?.message} />
                      )}
                    </div>
                  </div>
                  {/* Brokerage Details */}
                  <div className="col-12 border-bottom mb-2">
                    <h6 className="text-primary">Brokerage Details</h6>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        OD Brokerage %<span className="danger">*</span>
                      </label>
                      <input
                        type="number"
                        onFocus={numberWheelChange}
                        className="form-control"
                        id="od_brokerage_perc"
                        name="od_brokerage_perc"
                        {...register("od_brokerage_perc", {
                          required: "This is required.",
                        })}
                      />
                      {errors.od_brokerage_perc && (
                        <ErrorLabel
                          message={errors.od_brokerage_perc?.message}
                        />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        OD Brokerage Amount
                        <span className="danger">*</span>
                      </label>
                      <input
                        type="number"
                        onFocus={numberWheelChange}
                        className="form-control"
                        id="od_brokerage_amount"
                        name="od_brokerage_amount"
                        {...register("od_brokerage_amount", {
                          required: "This is required.",
                        })}
                      />
                      {errors.od_brokerage_amount && (
                        <ErrorLabel
                          message={errors.od_brokerage_amount?.message}
                        />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        TP Brokerage %<span className="danger">*</span>
                      </label>
                      <input
                        type="number"
                        onFocus={numberWheelChange}
                        className="form-control"
                        id="tp_brokerage_perc"
                        name="tp_brokerage_perc"
                        {...register("tp_brokerage_perc", {
                          required: "This is required.",
                        })}
                      />
                      {errors.tp_brokerage_perc && (
                        <ErrorLabel
                          message={errors.tp_brokerage_perc?.message}
                        />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        TP Brokerage Amount
                        <span className="danger">*</span>
                      </label>
                      <input
                        type="number"
                        onFocus={numberWheelChange}
                        className="form-control"
                        id="tp_brokerage_amount"
                        name="tp_brokerage_amount"
                        {...register("tp_brokerage_amount", {
                          required: "This is required.",
                        })}
                      />
                      {errors.tp_brokerage_amount && (
                        <ErrorLabel
                          message={errors.tp_brokerage_amount?.message}
                        />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Total Brokerage Amount&nbsp;
                        <span className="danger">*</span>
                      </label>
                      <input
                        type="number"
                        onFocus={numberWheelChange}
                        className="form-control"
                        id="total_brokerage_amount"
                        name="total_brokerage_amount"
                        {...register("total_brokerage_amount", {
                          required: "This is required.",
                        })}
                      />
                      {errors.total_brokerage_amount && (
                        <ErrorLabel
                          message={errors.total_brokerage_amount?.message}
                        />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Reward %<span className="danger">*</span>
                      </label>
                      <input
                        type="number"
                        onFocus={numberWheelChange}
                        className="form-control"
                        id="reward_perc"
                        name="reward_perc"
                        {...register("reward_perc", {
                          required: "This is required.",
                        })}
                      />
                      {errors.reward_perc && (
                        <ErrorLabel message={errors.reward_perc?.message} />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Reward Amount
                        <span className="danger">*</span>
                      </label>
                      <input
                        type="number"
                        onFocus={numberWheelChange}
                        className="form-control"
                        id="reward_amount"
                        name="reward_amount"
                        {...register("reward_amount", {
                          required: "This is required.",
                        })}
                      />
                      {errors.reward_amount && (
                        <ErrorLabel message={errors.reward_amount?.message} />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Enhance Brokerage %<span className="danger">*</span>
                      </label>
                      <input
                        type="number"
                        onFocus={numberWheelChange}
                        className="form-control"
                        id="enhance_brokerage_perc"
                        name="enhance_brokerage_perc"
                        {...register("enhance_brokerage_perc", {
                          required: "This is required.",
                        })}
                      />
                      {errors.enhance_brokerage_perc && (
                        <ErrorLabel
                          message={errors.enhance_brokerage_perc?.message}
                        />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Enhance Brokerage Amount
                        <span className="danger">*</span>
                      </label>
                      <input
                        type="number"
                        onFocus={numberWheelChange}
                        className="form-control"
                        id="enhance_brokerage_amount"
                        name="enhance_brokerage_amount"
                        {...register("enhance_brokerage_amount", {
                          required: "This is required.",
                        })}
                      />
                      {errors.enhance_brokerage_amount && (
                        <ErrorLabel
                          message={errors.enhance_brokerage_amount?.message}
                        />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Net Brokerage Amount
                        <span className="danger">*</span>
                      </label>
                      <input
                        type="number"
                        onFocus={numberWheelChange}
                        className="form-control"
                        id="net_brokerage_amount"
                        name="net_brokerage_amount"
                        {...register("net_brokerage_amount", {
                          required: "This is required.",
                        })}
                      />
                      {errors.net_brokerage_amount && (
                        <ErrorLabel
                          message={errors.net_brokerage_amount?.message}
                        />
                      )}
                    </div>
                  </div>

                  {/* Payment Detials  */}
                  <div className="col-12 border-bottom mb-2">
                    <h6 className="text-primary">Payment Detials </h6>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div class="form-group has-search">
                      <label for="payment_date" class="form-label">
                        Payment Date <span class="text-danger">*</span>
                      </label>
                      <span class="fa fa-calendar form-control-feedback"></span>
                      <Controller
                        name="payment_date"
                        id="payment_date"
                        control={control}
                        render={({ field }) => (
                          <Flatpickr
                            {...field}
                            onChange={(value) => {
                              var date = new Date(value).toISOString();
                              setValue(
                                "payment_date",
                                moment(date).format("DD-MM-YYYY")
                              );
                            }}
                            id="disabled-picker"
                            className="form-control"
                            options={{
                              dateFormat: "d-m-Y",
                              maxDate: watchPolicyStartDate,
                              enableTime: false,
                            }}
                          />
                        )}
                        rules={{
                          required: "This is required.",
                        }}
                      />
                      {errors.payment_date && (
                        <ErrorLabel message={errors.payment_date?.message} />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Paid Through&nbsp;<span className="danger">*</span>
                      </label>
                      <select
                        className="form-control"
                        id="paid_through"
                        name="paid_through"
                        readOnly={initialData}
                        placeholder="Select.."
                        {...register("paid_through", {
                          required: "This is required.",
                        })}
                      >
                        <option value="Self Paid">Self Paid</option>
                        <option value="CD Paid">CD Paid</option>
                      </select>
                      {errors.paid_through && (
                        <ErrorLabel message={errors.paid_through?.message} />
                      )}
                    </div>
                  </div>
                  <div className="col-12 mb-3">
                    <div className="form-group">
                      <label className="label-control">COPS Remark</label>
                      <textarea
                        className="form-control"
                        id="cops_remark"
                        name="cops_remark"
                        maxLength="200"
                        {...register("cops_remark", {
                          maxLength: {
                            value: 200,
                            message: "Maximum 200 characters allowed.",
                          },
                        })}
                      />
                    </div>
                  </div>
                  {/* Document Detials  */}
                  <div className="col-12 border-bottom mb-2">
                    <h6 className="text-primary">Document Detials </h6>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Policy Document Status <span className="danger">*</span>
                      </label>
                      <select
                        className="form-control"
                        id="policy_doc_status"
                        name="policy_doc_status"
                        onChangeCapture={(event) => {
                          const selectedOption =
                            event.target.options[event.target.selectedIndex];
                          const selectedLabel = selectedOption.label;
                          setDocStatus(selectedLabel);
                        }}
                        {...register("policy_doc_status", {
                          required: "This is required.",
                        })}
                      >
                        <option value="">Policy Doc Status</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                      {errors.policy_doc_status && (
                        <ErrorLabel
                          message={errors.policy_doc_status?.message}
                        />
                      )}
                      {docStatus === "Yes" && policyStatus === "No" && (
                        <p className="text-danger">
                          Please Correct Policy Number Received Status
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Broker Details
                        <span className="danger">*</span>
                      </label>
                      <select
                        id="brokers_details"
                        name="brokers_details"
                        className="form-control"
                        {...register("brokers_details", {
                          required: "This is required.",
                        })}
                      >
                        <option value="">Select</option>
                        <option value="PINC">PINC</option>
                        <option value="Others">Others</option>
                      </select>

                      {errors.brokers_details && (
                        <ErrorLabel message={errors.brokers_details?.message} />
                      )}
                    </div>
                  </div>
                  {/* IF POLICY Doc status is No then show remark Field */}
                  {docStatus === "No" && (
                    <>
                      <div className="col-12">
                        <div className="form-group">
                          <lable>Reason</lable>
                          <textarea
                            className="form-control"
                            id="doc_reason"
                            name="doc_reason"
                            maxLength="200"
                            {...register("doc_reason", {
                              maxLength: {
                                value: 200,
                                message: "Maximum 200 characters allowed.",
                              },
                            })}
                          />
                        </div>
                      </div>
                    </>
                  )}
                  {/* END */}
                  {/* START : if policy doc status is Yes then show upload document option shown as bellow */}
                  {docStatus === "Yes" && (
                    <>
                      <div className="col-12 mt-4">
                        <div
                          {...getRootProps2({ className: "dropzone" })}
                          className="border-dashed text-center p-3 bg-light rounded border-secondary shadow"
                        >
                          <span className="badge bg-primary rounded p-2">
                            <input
                              accept=""
                              name="file"
                              {...getInputProps2()}
                            />
                            <i className="fa fa-plus" />
                          </span>{" "}
                          <span>Add Files</span>
                        </div>
                        <span
                          id="document_required"
                          className="d-none  text-danger fs-7 mx-auto "
                        >
                          {" "}
                          Document is required
                        </span>
                        {thumbs2}
                        {attachment2.length > 3 && (
                          <button
                            type="btn"
                            className="btn btn-primary rounded mt-4"
                            onClick={(e) => {
                              e.preventDefault();
                              removeAll2();
                            }}
                          >
                            Remove All
                          </button>
                        )}
                        {fileRejections2.length > 0 && (
                          <div className="mt-2">{fileRejectionItems2}</div>
                        )}

                      </div>
                      <div className="col-12 mt-1">
                        <div className="row">
                          {document && document.length > 0 ? (
                            document.map((objLink, index) => (
                              <>
                                <div className="col-12 col-md-4 col-xl-3">
                                  <div className="card shadow bg-light rounded mb-1 ">
                                    <div className="card-body d-flex justify-content-between py-1">
                                      <a
                                        className="primary"
                                        onClick={() => {
                                          dispatch(actionDownload({ dmsIds: [objLink?.id] }));
                                        }}
                                      >
                                        {objLink.actual_uploaded_file_name}
                                      </a>
                                      <span className="cursor-pointer">
                                        {" "}
                                        <i
                                          size={16}
                                          className="fa fa-trash btn btn-sm primary2"
                                          onClick={() => {
                                            Swal.fire({
                                              icon: "warning",
                                              text: "Are you sure, you want to delete this document?",
                                              cancelButtonText: "Cancel",
                                              showCancelButton: true,
                                            }).then(({ isConfirmed }) => {
                                              if (isConfirmed) {
                                                $(
                                                  "#progress-loader"
                                                ).removeClass("hidden");
                                                // props.actionDeleteDocument({
                                                //   policy_id:
                                                //     proposalPoolViewDetails?.id,
                                                //   dms_id: objLink?.id,
                                                // });
                                              }
                                            });
                                          }}
                                        ></i>
                                      </span>
                                      <a
                                        id="downloadLink"
                                        className="d-none"
                                      ></a>
                                    </div>
                                  </div>
                                </div>
                              </>
                            ))
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  {/* END */}
                </div>
              </div>
              {/* document */}

              <div className="form-actions border-0 float-none mt-1">
                {
                  loading ?
                    <button
                      id="add_edit_policy"
                      className="btn btn-primary shadow round text-uppercase me-2"
                      type="submit"
                    >
                      <div className="d-flex align-items-center">
                        Submit
                        <span
                          id="add-edit-policy-loader"
                          className="spinner-border spinner-border-sm ml-half hidden"
                        ></span>
                      </div>
                    </button>
                    :
                    <button
                      id="add_edit_policy"
                      className="btn btn-primary shadow round text-uppercase me-2"
                      type="submit"
                    >
                      <div className="d-flex align-items-center">
                        Submit
                      </div>
                    </button>
                }
                {
                  !initialData &&
                  <button
                    className="btn btn-outline-secondary mr-1 shadow round text-uppercase"
                    onClick={(event) => {
                      event.preventDefault();
                      navigate(-1);
                    }}
                  >
                    {" "}
                    Cancel
                  </button>
                }
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default PolicyForm;
